module.exports = __webpack_public_path__ + "static/media/UnderMaintenance.63ed6190.jpg";